import { useMediaQuery } from "@mui/material";
import { SignUpPage } from "~/pages";

/** Padded wrapper for SignUpPage inside the public shell. */
export const SignUpPageContent = () => {
  const smallScreen = useMediaQuery("(max-width: 465px)");

  return (
    <div
      style={{
        flex: 1,
        padding: smallScreen ? "0.5rem" : "2rem",
      }}
    >
      <SignUpPage />
    </div>
  );
};
